import React from "react";
import "./Muhammadabad.css"; // Reuse your CSS
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Azamgarh = () => {
  return (
    <div className="dp-page">

      <Helmet>
        <title>Popular Aluminium Works in Azamgarh, Uttar Pradesh | Trusted Fabricators</title>
        <meta
          name="description"
          content="Find top aluminium works in Azamgarh, Uttar Pradesh. Skilled fabricators provide sliding windows, aluminium doors, partitions, kitchen cupboards, ACP works, and custom aluminium solutions for homes and commercial properties."
        />
        <meta
          name="keywords"
          content="Aluminium Works Azamgarh UP, Aluminium Fabricators, Sliding Windows, Aluminium Doors, Partitions, Kitchen Cupboards, ACP Works, Custom Aluminium Work, Window Installation"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social */}
        <meta property="og:title" content="Popular Aluminium Works in Azamgarh, Uttar Pradesh" />
        <meta
          property="og:description"
          content="Trusted aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, ACP works, and custom solutions for homes and commercial properties in Azamgarh."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Popular Aluminium Works in Azamgarh, Uttar Pradesh" />
        <meta
          name="twitter:description"
          content="Skilled aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, ACP works, and custom solutions in Azamgarh, Uttar Pradesh."
        />
      </Helmet>

      {/* HERO SECTION */}
      <section className="dp-section">
        <div className="dp-container dp-split">
          <div>
            <h1>Popular Aluminium Works in Azamgarh, Uttar Pradesh</h1>
            <p>
              Azamgarh is known for its thriving aluminium fabrication industry, serving homes, shops, offices, and commercial properties. From sliding windows and aluminium doors to partitions, kitchen cupboards, and ACP works, local fabricators provide durable, stylish, and cost-effective solutions tailored to modern construction needs.
            </p>
          </div>
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765908421/WhatsApp_Image_2025-12-16_at_10.06.41_AM_mdtfzb.jpg"
            alt="aluminium-works-azamgarh"
          />
        </div>
      </section>

      {/* WHY ALUMINIUM WORKS */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Why Aluminium Works Are Essential in Azamgarh</h2>
          <p>
            Aluminium works in Azamgarh are highly sought after due to their strength, modern design, and low maintenance. Trusted local fabricators specialize in sliding windows, aluminium doors, partitions, kitchen cupboards, glass panels, and ACP works, ensuring precise fitting and long-lasting performance for residential and commercial projects.
          </p>
          <p>
            Additional options like powder-coated frames, toughened glass, and custom designs make aluminium solutions highly adaptable to different architectural styles and customer preferences.
          </p>
        </div>
      </section>

      {/* TRUSTED FABRICATORS */}
      <section className="dp-section dp-box-layout">
        <img
          src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_1_fynu60.jpg"
          alt="trusted-fabricators-azamgarh"
        />
        <div className="dp-box">
          <h2>Trusted Aluminium Fabricators in Azamgarh</h2>
          <p>
            Local fabricators in Azamgarh are known for their expertise, timely installation, and personalized service. From initial measurement to final installation, experienced workshops guide customers on aluminium grades, glass thickness, and hardware, ensuring high-quality results.
          </p>
          <p>
            Many fabricators also serve nearby towns and villages, offering professional service, transparent pricing, and after-sales support for smooth project completion.
          </p>
        </div>
      </section>

      {/* SLIDING WINDOWS & DOORS */}
      <section className="cp-page">
        <section className="cp-scroll">
          <div className="cp-scroll-text">
            <h2>Aluminium Sliding Windows and Doors</h2>
            <p>
              Sliding aluminium windows are especially popular in Azamgarh for their modern appearance and space-saving design. Ideal for bedrooms, kitchens, offices, and balconies, they offer smooth operation and easy maintenance. Aluminium sliding doors with glass panels enhance shopfronts and commercial interiors with a combination of style, security, and durability.
            </p>
          </div>
          <div className="cp-scroll-img"></div>
        </section>
      </section>

      {/* CUSTOM FABRICATION */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Custom Aluminium Fabrication and ACP Works in Azamgarh</h2>
          <p>
            Fabricators in Azamgarh provide custom solutions for aluminium partitions, window grills, office cabins, kitchen cupboards, glass panels, and ACP front elevations. Customized work ensures proper fitting, elegant finishing, and long-term durability. Many workshops also offer repair and replacement services for sliding systems, locks, and glass installations.
          </p>
        </div>
      </section>

      {/* SERVICE AREAS */}
      <section className="dp-section">
        <div className="dp-container dp-box-layout">
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1766165233/Screenshot_2025-12-19_225650_raucxl.png"
            alt="service-areas-azamgarh"
          />
          <div className="dp-box">
            <h2>Serving Azamgarh and Nearby Regions</h2>
            <p>
              Aluminium works in Azamgarh are widely available across nearby towns, villages, and marketplaces. This allows homeowners, shopkeepers, and builders to schedule measurements, site visits, and installations quickly, ensuring timely project completion and cost-effective solutions.
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="aluminium-content">
        <div className="container">
          <h1>Choosing Aluminium Works in Azamgarh</h1>
          <p>
            Azamgarh has emerged as a trusted destination for aluminium fabrication, sliding windows, doors, partitions, kitchen cupboards, glass works, and ACP solutions. Local dealers provide quality workmanship, modern design, and long-lasting performance for homes, offices, and commercial projects.
          </p>

          <h2>Top Aluminium Fabricators in Azamgarh</h2>
          <p>
            Leading fabricators specialize in aluminium windows, doors, partitions, grills, and decorative works. They ensure durable installations and timely service, catering to a variety of residential and commercial needs.
          </p>

          <h2>Top Aluminium Door Dealers in Azamgarh</h2>
          <p>
            Aluminium doors are highly sought after for their durability, aesthetic appeal, and security features. Trusted dealers in Azamgarh provide a wide range of styles for homes, offices, and commercial establishments.
          </p>

          <h2>Sliding Window Solutions in Azamgarh</h2>
          <p>
            Sliding windows are popular for their easy operation, modern look, and space-saving design. Fabricators also offer custom sizes, mosquito mesh, safety grills, and powder-coated finishes to suit different interiors and exteriors.
          </p>

          <h2>Kitchen Cupboards & Custom Aluminium Works</h2>
          <p>
            Aluminium kitchen cupboards, partitions, and office cabins are designed for durability, modern aesthetics, and low maintenance. Custom solutions ensure perfect fitting and superior finishing for both residential and commercial projects.
          </p>

          <h2>ACP & Front Elevation Works</h2>
          <p>
            Many fabricators in Azamgarh specialize in ACP panel works for front elevations, facades, and interiors. These installations provide a contemporary appearance, strength, and easy maintenance for commercial and residential buildings.
          </p>

          <h2>Top Hardware Dealers in Azamgarh</h2>
          <p>
            Hardware dealers supply locks, handles, fittings, and other essential accessories for aluminium, glass, and ACP works, ensuring smooth operation and lasting performance.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="dp-cta">
        <h2>Book Your Aluminium Work Today in Azamgarh, Uttar Pradesh</h2>
        <Link to="/contact"><button>Contact Us</button></Link>
      </section>

    </div>
  );
};

export default Azamgarh;
